var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcQuantity1K(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 42,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2414_17973",
    transform: "translate(0 0.00133415) scale(0.00862069 0.00882594)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2414_17973",
    width: 116,
    height: 113,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHQAAABxCAYAAAAEV4eUAAAACXBIWXMAAAsSAAALEgHS3X78AAAEkUlEQVR4nO2dwW3bShCGvwS+2zmTQJQKnjuwOngCWECUDtRB+DqwKghdAAG7gqdUEKuCWAB5typwDlwKsiKJK5vU7A7mu8VWvMN82sXuKv7nw8vLC6GSlvUIGAmXsY+nKkuepIvYx4fQhDqJM2ACfJat5igroABuqyx5Fq5lQ1BC07KeATlwKVzKKayBWZUlhXQhEJDQtKwL4KtwGe/hrsqSqXQRH6ULAEjLOidumQBf3QojivgMTcv6GvglWkS/fJHcMIUwQ2+lC+iZXHJw0RnqdrS/xQoYjk9SO1/pGToWHn8oxlIDX0gN7Bh5vu4BeBywDl+ugX89X3c/cC17kRbqQxDHgZbQj1fSS64PhXQBOxTSBRwjBqHGCZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZZhQZcQg9Eq6gB1Cq+cVMQgtXJaROK6OQrqOY8SQsXAJ/ErLWrqOUxALc5SeoQvh8YdiITVwCNFwz8SVvtnFqsqSkdTg0jMU9EXDFZKDhyJ0JV1ETyyrLMklCxAX6jLxJjRBwjGzBqbSRYgLBaiy5JEmHy9WqStg7J5DlCCEwkbqCLgTLuVU5sB1CDIhgF3uPlzs6oRm1oZ4M/NMczQpQmogAIEKNd5OMEuu0Q9eV3/uDjO0pS/YZjiSHFxy07Ie0zTE8Qn8lWJNEzSc9yE3LesrmqPHmCbEOLRGQEuaIOj7Kkv2Biz/JdRtSArgZuDi+mZOI/ZNmxTXamRGPNeQK2BaZcli+4uvhLqldUE8D7XLkuY86C3VzcoF8M9QRQ3Mf9u3U5tNkZuZC+KVCY0U76x3BTIBvrvVBXi9yy2IW2bLzfYDdpATt8yW727P0yy57g//i5bUL2tgdGzpVdgzZlVlyaidoeI9u3rmku6L8nz4Ms7K57SsJ63QkI8mb2Xc8f3JOYo4M5OLE/4D1powmuGA35Hq4HO5Z9awX9hldIHfDdCaQD4eAkjLegr86HjZsUsB31uvb6E0evVsAHTje5f7GIpMgDP9I89DkQng213KLucPE9THYr6YUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGWYUGX4Cr1xvwYfBO7X04dmFkoDINjEEHRyATx5/swfaVl35RqExPKdf/8SWKRlHUoUgU9QyLINnnoivOTJ93J3LJcgLWuNyc8P7ZK7kKxiILoy/x7OUsV5uW+F5pJVDMDqUJ7sFt4hj5GwphXqwoPnouX0S2fUnYus+Tl8KWcjr7LkebPLrbJkxvs3EiEw95idLVPi7RWzzc8qS27h72PLmLjftXP3xvTCrUxj4pa6ZCu3cG/mfKRx3bMTZuYrYo5l330DH2sicEVjfkKkgfqnEknjhBXNqWRv4wRrxHOAQFubPHbl6f8BBVNP69bRfb8AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQuantity1K);
export default __webpack_public_path__ + "static/media/ic-quantity-1k.0a22db7c97be3a5b5626d310b509208e.svg";
export { ForwardRef as ReactComponent };